import { render, staticRenderFns } from "./role-ope.vue?vue&type=template&id=05aeb68c&scoped=true&"
import script from "./role-ope.vue?vue&type=script&lang=js&"
export * from "./role-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aeb68c",
  null
  
)

export default component.exports